import {ICity, IConstants, IPromoSectionData, ISection} from "../../model/B2CInfo";
import React, {useContext, useEffect, useState} from "react";
import {AppContext} from "../../../App";
import './PromoItem.css'
import {Drawer} from "@material-ui/core";
import backIcon from '../../../imgs/back_arrow.png'
import radioItemSelected from '../../../imgs/radio-item-selected.png'
import radioItemNotSelected from '../../../imgs/radio-item.not-selected.png'
import blueArrow from '../../../imgs/blue_arrow.png'
import PromoCarousel from "./PromoCarousel";
import {trackGoal} from "../../../helpers/tracker";
import {ISession} from "../../../networking/Options";
import {Link} from "react-router-dom";
import {getMobileAppPromo} from "../../../helpers/getMobileAppPromo";

interface MobilePromoItemProps {
    section: ISection
    constants: IConstants,
    session?: ISession
    city: ICity
    onSelected: (city: ICity) => void
}

export default function MobilePromoItem(props: MobilePromoItemProps) {
    const [citySelectorOpen, setCitySelectorOpen] = useState(false);
    const [width, setWidth] = useState(window.innerWidth);

    useEffect(() => {
        function handleResize() {
            setWidth(window.innerWidth)
        }

        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize);
    }, [])

    let data = (props.section.data as IPromoSectionData)

    const isUserRegistered = props.session?.user.details.status !== "onboarding" && props.session != null;
    const registerButtonTitle = isUserRegistered ? "Скачать Драйв" : data.button_title;

    const appContext = useContext(AppContext);
    const menuItems = props.city.sections.flatMap((item) => {
        if (!item.show_in_header) {
            return null;
        }
        return <a key={item.id} onClick={(e) => {
            window.document
                .querySelector(`#${item.id}`)
                ?.scrollIntoView({behavior: "smooth", block: "start"});
            trackGoal(`tap_${item.id}`);
        }}>{item.name}</a>;
    });

    let cities = (appContext?.b2cInfo.cities ?? []).map((c) => {
        return <a key={c.name} className="City_selector_bottom_sheet_item" onClick={(e) => {
            props.onSelected(c)
            setCitySelectorOpen(false)
        }}>
            <img src={c == props.city ? radioItemSelected : radioItemNotSelected}/>
            {c.name}
        </a>
    })

    let appPromo = getMobileAppPromo(props.constants)

    return <div className="Mobile_promo_item">
        <div className="Mobile_promo_item_title">
            {data.title}
        </div>
        <button className="Mobile_promo_item_button" onClick={(e) => {
            window.open(appPromo.link, "_blank")
            trackGoal("tap_register");
        }}>
            {registerButtonTitle}
        </button>
        <PromoCarousel key={width} section={props.section}/>
        <div className="Mobile_promo_item_menu_container">
            <div className="Mobile_promo_item_city_selector" onClick={(e) => setCitySelectorOpen(true)}>
                {props.city.name}
                <img className="Mobile_promo_item_city_selector_image" src={blueArrow}/>
            </div>
            {menuItems}
        </div>
        <Drawer anchor="bottom" open={citySelectorOpen} onClose={(e) => setCitySelectorOpen(false)}
                PaperProps={{elevation: 0, style: {backgroundColor: "transparent"}}}>
            <div className="City_selector_bottom_sheet">
                <div className="City_selector_bottom_sheet_header">
                    <div style={{width: "50px", height: "50px", objectFit: "contain", position: "absolute"}}
                         onClick={(e) => setCitySelectorOpen(false)}>
                        <img style={{width: "12px", height: "23px", objectPosition: "center", marginTop: "22px"}}
                             src={backIcon}/>
                    </div>
                    <span>Выберите ваш город</span>
                </div>
                {cities}
            </div>
        </Drawer>
    </div>
}